<template>
    <div>

        <!-- FILTER START -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label for="partshopCode">Search</label>
                        <input type="text" class="form-control" v-model="filter.search" placeholder="Type username">
                    </div>
                    <div class="col-md-3 offset-md-6 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="height:38px; margin-bottom:0.5%"
                            @click="vue_universal_table.update++"
                        >Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- FILTER END -->

        <div class="bg-white shadow box-content mt-5">
            <vue-universal-table
                api_url="/api/user/userDashboardList"
                :filter="filter"
                :special_buttons="['newUser']"
                :buttons="vue_universal_table.buttons"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :process_data="vue_universal_table.process_data"

                sort_order="DESC"
                sort_by="id"

                @onNewUser="modal.new = true"
                @onEdit="editUser"
                @onDelete="deleteUser"
            ></vue-universal-table>
        </div>

        <cu-user-management
            v-if="modal.new || modal.edit"
            :data="modal.edit ? modal.editData : null"
            api_new="/api/user/userDashboardRegister"
            api_edit="/api/user/updateUserDashboard"
            form_type="User Dashboard"
            :is_company_exist="false"
            @refreshData="vue_universal_table.update++;"
            @closeModal="modal.new = false; modal.edit = false;"
        ></cu-user-management>

    </div>
</template>

<script>
    import cuUserManagement from './children/CUUserManagement'

    export default {
        metaInfo : {
            title : 'Dashboard User Management'
        },
        data () {
            return {
                modal : {
                    new : false,
                    edit : false,
                    editData : false
                },

                filter : {
                    search : ''
                },
                vue_universal_table : {
                    buttons : [
                        {title:"Edit", variable:null, class:"fas fa-edit btn-outline-primary"},
                        {title:"Delete", variable:"id", class:"fas fa-trash btn-outline-danger"},
                    ],
                    fields : [
                        {title:"Username", variable:"username"},
                        {title:"Type", variable:"type"},
                        {title:"Status", variable:"status", style_condition:{
                            'ACTIVE' : 'color:green; font-weight:bold',
                            'INACTIVE' : 'color:red; font-weight:bold'
                        }},
                        {title:"Last Login", variable:"last_login"},
                    ],
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].last_login = data[i].last_login ? data[i].last_login : 'N/A'
                        }
                    `,
                },
            }
        },
        components : {
            cuUserManagement
        },
        mounted () {

        },
        methods : {
            editUser (user) {
                this.modal.editData = JSON.parse(user);
                this.modal.edit = true;
            },
            deleteUser (userId) {
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "You are about to end this (man/woman)'s whole career!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete("/api/user/deleteUserDashboard?id=" + userId)
                        .then((resp)=>{
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `User has been successfully deleted`
                            })
                        })
                        .catch((error)=>{
                            console.log('%cerror DashboardUserUM.vue line:78 ', 'color: red; display: block; width: 100%;', err);
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : err.response.data.message
                            })
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .box-content {
        padding: 20px;
        border-radius: 10px;
    }
</style>